import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


const PaymentRedirectPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  useEffect(() => {
    if (!state || !state.ccavenueUrl || !state.access_code || !state.encRequest) {
      // If required data missing, navigate to error or back to registration
      navigate('/payment/error');
      return;
    }

    // Construct form and submit
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = state.ccavenueUrl;

    const inputEnc = document.createElement('input');
    inputEnc.type = 'hidden';
    inputEnc.name = 'encRequest';
    inputEnc.value = state.encRequest;
    form.appendChild(inputEnc);

    const inputAccess = document.createElement('input');
    inputAccess.type = 'hidden';
    inputAccess.name = 'access_code';
    inputAccess.value = state.access_code;
    form.appendChild(inputAccess);

    document.body.appendChild(form);
    form.submit();

    // Cleanup if component unmounts (optional)
    return () => {
      document.body.removeChild(form);
    };
  }, [state, navigate]);

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>Redirecting to payment gateway…</h2>
      <p>Please wait while we redirect you to the secure payment page.</p>
    </div>
  );
};

export default PaymentRedirectPage;
